import ExportFileMixin from "../../mixins/export-file";

Vue.component("quotes-invoices", {

    mixins: [ExportFileMixin],

    data () {
        return {
            searchParams: {
                filter_text: "",
                types_filter: ["invoice"],
            },
            columns: [
                {
                    name: "date",
                    title: "Date",
                    dataClass: "",
                },
                {
                    name: "__slot:type",
                    title: "Type",
                },
                {
                    name: "asset",
                    title: "Property",
                    dataClass: "",
                },
                {
                    name: "contact_full_name",
                    title: "Contact",
                    dataClass: "",
                },
                {
                    name: "quote_invoice_reference",
                    title: "Reference",
                    dataClass: "",
                }, {
                    name: "status",
                    title: "Status",
                    dataClass: "",
                }, {
                    name: "total_incl",
                    title: "Total Incl.",
                    titleClass: "text-right",
                    dataClass: "text-right",
                }, {
                    name: "__slot:actions",
                    title: "",
                    titleClass: "center aligned",
                    dataClass: "text-right"
                }
            ]
        };
    },

    methods: {
        isTypeFilterActive (documentType) {
            return this.searchParams.types_filter.includes(documentType);
        },

        toggleTypeFilter (documentType) {
            if (this.isTypeFilterActive(documentType)) {
                let index = this.searchParams.types_filter.indexOf(documentType);
                if (index > -1)
                    this.searchParams.types_filter.splice(index, 1);
            } else {
                this.searchParams.types_filter.push(documentType);
            }

            this.doFilter();
        },

        onActionClick (action, data) {
            switch (action) {
                case "open-ticket":
                    window.open("/tickets/" + data.ticket_id + "?open-quotes-invoices-panel=true", "_blank");
                    break;
                case "view-document":
                    if (data.last_document_url) {
                        window.open(data.last_document_url, "_blank");
                    } else {
                        swal({
                            position: "middle-middle",
                            type: "info",
                            title: "No document generated yet",
                            text: "Go to the ticket, and open the quote / invoice record to compile the document.",
                            showConfirmButton: true,
                        });
                    }
                    break;
            }
        },

        onPaginationData (paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
            this.$refs.paginationInfo.setPaginationData(paginationData);
        },

        onChangePage (page) {
            this.$refs.vuetable.changePage(page);
        },

        doFilter () {
            Vue.nextTick(() => this.$refs.vuetable.refresh());
        },

        exportQuotesAndInvoices () {
            this.$set(this.searchParams, "sort", this.$refs.vuetable?.getSortParam());
            this.exportData("/quotes-invoices/export", this.searchParams, this.$dayjs().format("DD-MM-YYYY") + " Quotes_Invoices Export.xlsx");
        },
    },
});
